var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCryptodata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.996,
    height: 19.629,
    viewBox: "0 0 143.996 19.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M6.1,79.183V69.709Q6.1,67,9.482,67h10.38v1.915h-9.7c-.6,0-.9.243-.9.719v9.613c0,.486.3.719.9.719h9.707v1.915H9.482C7.23,81.892,6.1,80.986,6.1,79.183Z",
    transform: "translate(-6.1 -67)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M182.4,121.328v-8.306q0-2.522,3.158-2.522h3.84v1.691h-3.27c-.523,0-.794.215-.794.635v8.511l-2.934-.009Z",
    transform: "translate(-165.929 -106.436)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M269.3,110.4h2.962l3.924,8.016,3.924-8.016h2.952l-7.623,15.574h-2.952l2.214-4.559Z",
    transform: "translate(-244.71 -106.345)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M436,125.974V110.4h8.8c2.1,0,3.158.841,3.158,2.522V118.7c0,1.682-1.056,2.532-3.158,2.532h-5.867v4.737H436Zm2.934-6.437h5.307c.523,0,.794-.215.794-.635v-6.185c0-.42-.262-.635-.794-.635h-5.307Z",
    transform: "translate(-395.836 -106.345)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M595.4,79.36V67h2.934v4.064H602.4v1.691h-4.064v6.811c0,.42.262.635.794.635h3.27v1.691h-3.84C596.446,81.892,595.4,81.042,595.4,79.36Z",
    transform: "translate(-540.344 -67)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M696.8,118.8v-5.774q0-2.522,3.158-2.522H705.6c2.111,0,3.158.841,3.158,2.522V118.8c0,1.682-1.056,2.532-3.158,2.532h-5.643C697.856,121.328,696.8,120.478,696.8,118.8Zm2.934.206c0,.42.262.635.794.635h4.513c.523,0,.794-.215.794-.635v-6.185c0-.42-.262-.635-.794-.635h-4.513c-.523,0-.794.215-.794.635Z",
    transform: "translate(-632.271 -106.436)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M858.6,81.892V67h7.67q7.217,0,7.222,5.774v3.335q0,5.774-7.222,5.774l-7.67.009Zm3.167-1.925h4.064q4.513,0,4.513-3.606v-3.84q0-3.616-4.513-3.616h-4.064Z",
    transform: "translate(-778.955 -67)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1028.9,81.892l7-14.892h3.615l7,14.892H1043.3l-1.738-3.718h-7.717l-1.738,3.718Zm5.848-5.643h5.914l-2.952-6.316Z",
    transform: "translate(-933.345 -67)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1196.8,68.915V67h15.789v1.915h-6.316V81.892h-3.158V68.915Z",
    transform: "translate(-1085.558 -67)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1345.3,81.892l7-14.892h3.615l8.268,14.892h-4.475l-1.738-3.718h-7.717l-1.738,3.718Zm5.848-5.643h5.914l-2.952-6.316Z",
    transform: "translate(-1220.185 -67)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptodata);
export default __webpack_public_path__ + "static/media/cryptodata.c31407289ba4fef03b0d92f3dad45d58.svg";
export { ForwardRef as ReactComponent };